function formatArray(item) {
  return item
    .map((prop) => {
      const formattedProps = Object.entries(prop)
        .filter(([key]) => !key.startsWith("_"))
        .map(([key, value]) => {
          if (Array.isArray(value)) {
            const nestedArrayFormatted = formatNestedArray(value);
            return `${key}\n${nestedArrayFormatted}`;
          } else if (typeof value === "object") {
            return `${key}\n${formatObject(value)}`;
          }
          return `${key} ${value}`;
        })
        .join("\n");
      return formattedProps;
    })
    .join("\n");
}

function formatNestedArray(nestedArray) {
  return nestedArray
    .map((addressObj) => {
      const filteredAddressProps = Object.entries(addressObj)
        .filter(([key]) => !key.startsWith("_"))
        .map(([key, value]) => `${key} ${value}`)
        .join("\n");
      return filteredAddressProps;
    })
    .join("\n");
}

function formatObject(obj) {
  if (obj === null) {
    return "";
  }
  const formattedProps = Object.entries(obj)
    .filter(([key]) => !key.startsWith("_"))
    .map(([key, value]) => `${key} ${value}\n`)
    .join("");

  return formattedProps;
}

export function formatJSONData(jsonData) {
  let result = "";

  for (const key in jsonData) {
    if (!key.startsWith("_")) {
      result += Array.isArray(jsonData[key])
        ? `${key}\n${formatArray(jsonData[key])}`
        : typeof jsonData[key] === "object"
        ? `${key}\n${formatObject(jsonData[key])}`
        : `${key} ${jsonData[key]}\n`;
    }
  }

  return result;
}
